export const ADMINISTRATION = "Administration";
export const OVERVIEW = "Overview";
export const MY_CV = "MyCv";
export const CV = "Cv";
export const EXTERNAL_CV_UPLOADER = "ExternalCvUploader";
export const ERROR = "ERROR";
